import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import ChangeEmail from 'components/Account/PersonalDetails/ChangeEmail/ChangeEmail';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_ACCOUNT } from 'settings/gtm/gtmPageView';

export default function EditEmail(): JSX.Element {
  const { t } = useTranslation(['personalDetailsPage']);

  useGtmPageView(GTM_PAGE_ACCOUNT, '');

  return (
    <div>
      <Helmet>
        <title>
          {t('META_TITLE_TEMPLATE', {
            title: t('EDIT_EMAIL_META_TITLE'),
            ns: 'translation',
          })}
        </title>
      </Helmet>
      <ChangeEmail />
    </div>
  );
}
